import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import { customStyles } from "../../../../Bookclosure/Components/AddTaskModal";
import commoncss from "../../../css/common.module.css";
import buttoncss from "../../../css/button.module.css";
import Modal from "../../../elements/Modal";
import { Button } from "../../../elements/Button";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/calender.svg";
import InputGroup from "../../../elements/InputGroup";
import bookclosure_taskstatus from "../../../data/bookclosure_taskstatus.json";
import modules from "../../../data/modules.json";
import FilterRow from "../../../components/receivables/Listing/ListingReceivableFilterRow";
import CustomDropdownIndicator from "../../../elements/CustomDropdownIndicator";
import { receivablesListing, receivablesUploadFiles, GetReceivableMapping, saveReceivableMapping, GetSubReceivableMapping, subReceivablemapping, getAllReceivablesErpData, putReceivableFromERP } from '../../../../Bookclosure/Services/ApiHandler'


const ReceivableListingFilterModel = ({
  setReceivableListingFilterModel,
  handleClose,
  filterAttr,
  receivablesID,
  applyReceivablesListingFilter,
  filterOptions
}) => {
  const animatedComponents = makeAnimated();
  const [filterRows, setFilterRows] = useState([{}]);

  const addFilter = () => {
    setFilterRows((prev) => [...prev, {}]);
  };

  const updateFilterRow = (index, updated) => {
    setFilterRows((prev) => {
      return prev.map((row, i) => {
        if (i === index) {
          return typeof updated === "function"
            ? updated(row)
            : { ...row, ...updated };
        }
        return row;
      });
    });
  };

  const applyFilter = () => {
    const requestBody = {};
    const filteredRows = filterRows.filter((row) => row.field && row.value);
    const customFilters = filteredRows.map(row => ({
       field: row.field,
       dataType: row.dataType,
       type: row.filterType,
       value: row.value,
    }));

    // Add the custom filters array to the request body
    if (customFilters.length > 0) {
        requestBody.filters = customFilters;
    }
    console.log("FILTER PAYLOAD:", requestBody);

      applyReceivablesListingFilter( requestBody);
  }

  const removeFilterRow = (indexToRemove) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const clearAllFilters = () => {
    setFilterRows([]);
  };

  return (
    <Modal
      width={"45%"}
      minHeight={"350px"}
      title="Filters"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          {filterRows.length > 0 && (
            <label
              className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
              onClick={clearAllFilters}
            >
              Reset All
            </label>
          )}
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setReceivableListingFilterModel(false);
              handleClose();
            }}
            label="Cancel"
          />
          <span>
              <Button
                btnColor={buttoncss.secondary}
                label="Add Filter"
                onClick={addFilter}
              />
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Apply Filter"
              onClick={() => {
                applyFilter();
                handleClose()
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
          <>
            {filterRows.map((_, index) => (
              <>
                <span className="input-label mt-1">&nbsp;Where</span>
                <div style={{ display: "flex", gap: "10px" }}>
                  <FilterRow
                    key={index}
                    onChange={(data) => updateFilterRow(index, data)}
                    filterAttr={filterAttr}
                    onRemove={() => removeFilterRow(index)}
                    onApply={() => {
                      applyFilter();
                      handleClose();
                    }}
                  />
                </div>
              </>
            ))}
          </>
      </div>
    </Modal>
  );
};

export default ReceivableListingFilterModel;
